//marketplaceData.js
export const investmentOpportunities = [
  {
    id: 1,
    projectName: "Personalized Cancer Vaccine Manufacturing Facility",
    sector: "Biotechnology - Human Health",
    country: "Germany",
    owner: "Dr. Helen Smith",
    organization: "GeneCure Therapeutics",
    stage: "Feasibility",
    summary: "Seeking $180M investment to establish first Middle East facility for mRNA-based cancer vaccines in KAUST. Phase III clinical data shows 65% tumor reduction. Saudi partners gain exclusive MENA commercialization rights.",
    keyActivities: [
      "Localized production of patient-specific vaccines",
      "Training Saudi scientists in mRNA tech"
    ],
    productDescription: "FDA/EMA-approved platform (with Saudi SFDA fast-track potential)\n6-week turnaround from biopsy to dose",
    advantages: "40% cost advantage vs. European production\nPre-commitments from 3 Saudi hospital networks\n15-year Saudi government subsidy for biotech",
    links: ["www.genecure.de/mena-expansion"],
    documents: ["KAUST_LOI.pdf", "Vaccine_Production_Flowchart.jpg"],
    nextSteps: "Contact us for:\nExclusive investor presentation\nSaudi SFDA pre-submission meeting\nSite selection tour (Q1 2025)"
  },
  {
    id: 2,
    projectName: "AI-Powered Predictive Maintenance for Industrial IoT",
    sector: "Artificial Intelligence / Industrial Automation",
    country: "Germany",
    owner: "Alex Chen",
    organization: "NeuroFlow Analytics",
    stage: "Ready-to-Build",
    summary: "NeuroFlow Analytics provides an AI-driven predictive maintenance platform for industrial IoT systems. Our solution reduces equipment downtime by 40% through real-time anomaly detection. Targeting manufacturing and energy sectors, we offer scalable, explainable AI with seamless integration into existing IoT infrastructure. A pilot with a major automotive supplier showed a 30% reduction in maintenance costs. Seeking partners for deployment and funding to expand into EU and North American markets.",
    keyActivities: [
      "AI model training on industrial sensor data",
      "Integration with IoT platforms (Siemens, Rockwell)",
      "Pilot deployments in manufacturing plants"
    ],
    productDescription: "Cloud-based SaaS platform with real-time failure prediction\nCustomizable dashboards for maintenance teams\nAPI for ERP & SCADA system integration",
    advantages: "Proven ROI – Reduces maintenance costs by 30-40%\nScalable SaaS Model – Recurring revenue with high margins\nStrategic Partnerships – Collaborations with Siemens & Bosch\nFirst-Mover Edge – Explainable AI for industrial use",
    links: ["www.neuroflow-analytics.com"],
    documents: ["Whitepaper (PDF)", "Pilot performance report"],
    nextSteps: "Seeking $3M Seed Funding for R&D and market expansion.\nOpen to pilot projects with industrial partners."
  },
  {
    id: 3,
    projectName: "Autonomous Farming Robots – Spain Deployment",
    sector: "AgriTech / Robotics",
    country: "Spain",
    owner: "Maria Lopez",
    organization: "AgriBot Dynamics",
    stage: "Feasibility",
    summary: "AgriBot Dynamics develops autonomous robots for precision farming, reducing labor costs by 50% and increasing crop yield by 20%. Our modular robots perform planting, spraying, and harvesting with AI-driven vision. A prototype successfully operated on a 200-hectare tomato farm in Andalusia. Now seeking investment to commercialize and deploy in Southern Europe's high-value agriculture sector.",
    keyActivities: [
      "Robot hardware & software refinement",
      "Field trials with agribusinesses",
      "Regulatory compliance for autonomous farming"
    ],
    productDescription: "Self-driving robots with swarming capability\nSolar-powered, 12-hour continuous operation\nAI-based crop health monitoring",
    advantages: "Labor Shortage Solution – Cuts dependency on seasonal workers\nSustainability Focus – Reduces chemical/water usage by 15%\nHigh Demand – EU farmers face rising operational costs\nGrant Eligibility – Qualifies for EU Agri-Innovation funding",
    links: ["YouTube Link", "TechCrunch Article"],
    documents: ["Prototype test results (PDF)", "Business plan summary"],
    nextSteps: "Seeking $2.5M Series A for production scaling.\nPartnerships with agri-cooperatives for pilot programs."
  },
  {
    id: 4,
    projectName: "Smart Grid Energy Storage Network",
    sector: "Clean Energy / Grid Infrastructure",
    country: "Australia",
    owner: "Dr. Sarah Johnson",
    organization: "PowerFlow Systems",
    stage: "Ready-to-Build",
    summary: "PowerFlow Systems is deploying a network of distributed battery storage units that optimize grid stability and reduce peak demand charges by 35%. Our AI-controlled system has been validated with a major utility showing 22% reduction in brownouts. Seeking investment for full-scale implementation across Eastern Australia's vulnerable coastal grid network.",
    keyActivities: [
      "Battery hardware installation and networking",
      "Grid integration with existing infrastructure",
      "Machine learning deployment for demand prediction"
    ],
    productDescription: "Scalable battery network with 250kWh modular units\nReal-time load balancing and demand response\nUtility dashboard with predictive maintenance alerts",
    advantages: "Patent-protected energy distribution algorithm\nPerformance-based revenue model with utilities\nGovernment renewable incentive eligible\nScalable to both urban and rural deployments",
    links: ["www.powerflowsystems.com.au", "RenewEconomy feature article"],
    documents: ["Utility pilot results.pdf", "Technical specifications.xlsx"],
    nextSteps: "Seeking $12M Series B funding for manufacturing scale-up\nLooking for utility partnerships in Queensland and Victoria"
  },
  {
    id: 5,
    projectName: "Biodegradable Smart Packaging",
    sector: "Sustainable Materials / Food Technology",
    country: "Netherlands",
    owner: "Jan Verstegen",
    organization: "EcoPack Innovations",
    stage: "Commercialization",
    summary: "EcoPack creates fully biodegradable smart packaging for perishable foods that extends shelf life by 40%. Our seaweed-based material includes embedded sensors that change color based on food freshness. Successfully tested with Albert Heijn supermarkets, showing 25% reduction in food waste and strong consumer acceptance.",
    keyActivities: [
      "Material production scaling",
      "Supply chain integration with food producers",
      "Consumer education campaigns"
    ],
    productDescription: "Compostable packaging with 180-day shelf stability\nRFID-compatible freshness indicators\nCustomizable sizing for various food categories",
    advantages: "60% lower carbon footprint than conventional packaging\nCompetitive pricing achieved through proprietary process\nMultiple patents on material composition\nEU Circular Economy compliance certified",
    links: ["www.ecopack.nl", "Food Navigator Europe interview"],
    documents: ["Material safety certification.pdf", "Albert Heijn case study.pptx"],
    nextSteps: "Seeking €8M to expand production capacity\nExploring partnerships with premium food exporters\nExpansion into temperature-sensitive pharmaceuticals"
  },
  {
    id: 6,
    projectName: "Remote Healthcare Platform for Rural Communities",
    sector: "Digital Health / Telemedicine",
    country: "India",
    owner: "Priya Sharma, MD",
    organization: "MediConnect Rural",
    stage: "Growth",
    summary: "MediConnect Rural provides a low-bandwidth telemedicine platform connecting underserved communities to medical specialists. Our solution combines AI diagnostics with offline-capable mobile apps, reducing diagnosis time by 72% in areas with limited connectivity. Currently serving 230 villages in Karnataka with expansion planned throughout South India.",
    keyActivities: [
      "Healthcare provider network development",
      "Rural health worker training",
      "Diagnostic algorithm improvement"
    ],
    productDescription: "Mobile-first platform with offline sync capabilities\nAI-assisted preliminary diagnostics\nSecure electronic health records with biometric authentication",
    advantages: "Works on 2G networks unlike competitors requiring 4G\nIntegrates with India's Aadhaar identification system\nMicropayment system accommodating rural financial constraints\nEndorsed by Ministry of Health",
    links: ["www.mediconnect-rural.in", "WHO digital health spotlight"],
    documents: ["Karnataka health outcomes report.pdf", "Rural connectivity map.jpg"],
    nextSteps: "Seeking $5.5M Series B for expansion to Maharashtra and Tamil Nadu\nLooking for NGO partnerships for last-mile implementation\nExploring government subsidy programs"
  },
  {
    id: 7,
    projectName: "Modular Vertical Farming System",
    sector: "AgriTech / Urban Farming",
    country: "Singapore",
    owner: "Dr. Li Wei",
    organization: "UrbanHarvest Solutions",
    stage: "Scaling",
    summary: "UrbanHarvest develops modular vertical farming units for dense urban environments, producing 15x more yield per square meter than traditional farming. Our hydroponic systems are currently deployed in 12 locations across Singapore, producing leafy greens with 95% less water usage and zero pesticides. Ready for regional expansion.",
    keyActivities: [
      "System optimization for tropical climates",
      "Retail and restaurant distribution network development",
      "IoT environmental control enhancements"
    ],
    productDescription: "Stackable 2.5m² growing modules with integrated water recycling\nIoT monitoring and climate control system\nMobile app for harvest scheduling and nutrient management",
    advantages: "30% lower operating costs than competing systems\nSingapore '30 by 30' food security program approved vendor\nCustomizable crop selection for local preferences\nCarbon-neutral operations with solar integration",
    links: ["www.urbanharvest.sg", "Channel News Asia feature"],
    documents: ["Production metrics.pdf", "Food safety certification.pdf"],
    nextSteps: "Seeking $7M for expansion to Manila and Jakarta\nDeveloping hotel and restaurant direct supply program"
  },
  {
    id: 8,
    projectName: "Quantum Computing Security Protocol",
    sector: "Cybersecurity / Quantum Technology",
    country: "Canada",
    owner: "Dr. Michael Thornton",
    organization: "QuantumShield Technologies",
    stage: "Feasibility",
    summary: "QuantumShield has developed a quantum-resistant encryption protocol to protect critical infrastructure from emerging quantum computing threats. Our solution has been validated by NIST and successfully tested with a major Canadian financial institution, demonstrating seamless integration with legacy systems and negligible performance impact.",
    keyActivities: [
      "Algorithm optimization for enterprise deployment",
      "Compliance testing with financial regulations",
      "Development of hardware security module integration"
    ],
    productDescription: "Drop-in encryption library for existing security systems\nQuantum-resistant key generation and distribution\nReal-time threat monitoring and response system",
    advantages: "5-year lead on competing quantum-resistant solutions\nBackward compatible with classical encryption systems\nMinimal processing overhead (2.3% vs industry average 7.8%)\nComprehensive regulatory compliance package",
    links: ["www.quantumshield.ca", "CyberSec Today interview"],
    documents: ["NIST validation report.pdf", "Technical whitepaper.pdf"],
    nextSteps: "Seeking CAD $11M Series A for commercial launch\nTargeting financial sector partnership expansion\nExploring government infrastructure protection contracts"
  }
];

// Sample data for Investor Requests
export const investorRequests = [
  {
    id: 1,
    projectName: "Diabetes Treatment Technology",
    sector: "Biotechnology (Human Health)",
    investor: "Khalid Al-Mansouri",
    organization: "Al-Tamkeen Health Ventures",
    goal: "Seeking advanced biotech startups for diabetes treatment to establish manufacturing in Saudi Arabia.",
    preferredIndustry: "Biopharmaceuticals – Type 2 Diabetes Therapies",
    location: "Riyadh or Jazan Economic City",
    investmentType: "Equity",
    proposal: "Preference for GLP-1 analogs or oral insulin technologies with Phase II+ clinical data. Minimum $20M revenue potential in MENA.",
    roi: "Targeting 25% IRR with Saudi market exclusivity. Open to co-funding with SFDA fast-track support",
    links: ["www.altamkeenhealth.sa"],
    documents: ["Investment_Terms_2024.pdf", "SFDA_Regulatory_Roadmap.jpg"],
    nextSteps: "Contact us for:\nPitch deck review\nSFDA introduction meeting"
  },
  {
    id: 2,
    projectName: "Renewable Energy Storage Solutions",
    sector: "Clean Energy Technology",
    investor: "Mohammed Al-Farsi",
    organization: "Green Horizon Investments",
    goal: "Seeking innovative energy storage technologies to support Saudi Vision 2030 renewable energy targets.",
    preferredIndustry: "Grid-Scale Battery Storage – Focus on High Temperature Performance",
    location: "NEOM or King Abdullah Economic City",
    investmentType: "Equity with Royalty Options",
    proposal: "Interest in technologies with proven field deployment in desert conditions. Minimum 4-hour discharge capacity with 85% efficiency.",
    roi: "Targeting 20% IRR with Saudi market penetration. Access to PIF clean energy funding streams.",
    links: ["www.greenhorizoninvest.sa"],
    documents: ["Investment_Criteria_2024.pdf", "Saudi_Grid_Requirements.xlsx"],
    nextSteps: "Contact us for:\nTechnology evaluation\nSite visit to demonstration facilities"
  },
  {
    id: 3,
    projectName: "Water Desalination Technology",
    sector: "Water Technology",
    investor: "Fatima Al-Otaibi",
    organization: "Blue Desert Capital",
    goal: "Seeking energy-efficient water desalination technologies to reduce costs and environmental impact in Saudi coastal regions.",
    preferredIndustry: "Membrane Technology – Forward Osmosis Systems",
    location: "Jeddah or Yanbu Industrial City",
    investmentType: "Joint Venture",
    proposal: "Technologies demonstrating 30%+ energy reduction compared to conventional RO systems. Pilot-scale validation required.",
    roi: "Targeting 18% IRR with Saudi Water Partnership Company offtake agreements available.",
    links: ["www.bluedesertcapital.com.sa"],
    documents: ["Water_Tech_Requirements.pdf", "SWPC_Partnership_Framework.pdf"],
    nextSteps: "Contact us for:\nTechnical assessment meeting\nPilot project proposal review"
  },
  {
    id: 4,
    projectName: "Smart City Infrastructure",
    sector: "Urban Technology",
    investor: "Ahmad Al-Jabri",
    organization: "Future Cities Investment Group",
    goal: "Seeking IoT and AI-driven urban infrastructure solutions for Saudi smart city initiatives.",
    preferredIndustry: "Smart Transportation – Autonomous Vehicle Integration",
    location: "Riyadh or NEOM",
    investmentType: "Strategic Partnership with Equity",
    proposal: "Technologies with proven deployment in at least one major urban center. Must include data security and privacy compliance.",
    roi: "Targeting 22% IRR with Saudi government procurement advantage. Integration with Saudi Data AI Authority initiatives.",
    links: ["www.futurecitiesinvest.sa"],
    documents: ["Smart_City_Requirements.pdf", "SDAIA_Compliance_Guide.pdf"],
    nextSteps: "Contact us for:\nTechnology demonstration\nSaudi urban planner introductions"
  },
  {
    id: 5,
    projectName: "Advanced Manufacturing Technologies",
    sector: "Industrial Technology",
    investor: "Nasser Al-Qahtani",
    organization: "Saudi Industrial Ventures",
    goal: "Seeking Industry 4.0 technologies to transform traditional manufacturing in Saudi Arabia.",
    preferredIndustry: "3D Printing – Large-Scale Industrial Applications",
    location: "Dammam Industrial City or Jubail",
    investmentType: "Direct Investment with Technical License",
    proposal: "Technologies applicable to petrochemical component manufacturing with 40%+ production cost reduction. Material certification required.",
    roi: "Targeting 24% IRR with Saudi Aramco and SABIC potential customers. Local content incentives available.",
    links: ["www.saudiindustrialventures.com"],
    documents: ["Manufacturing_Investment_Guide.pdf", "Materials_Certification_Process.pdf"],
    nextSteps: "Contact us for:\nIndustrial site assessment\nSaudi Aramco supplier program introduction"
  },
  {
    id: 6,
    projectName: "Agricultural Technology Solutions",
    sector: "AgriTech",
    investor: "Layla Al-Harbi",
    organization: "Desert Bloom Investments",
    goal: "Seeking water-efficient agricultural technologies to enhance food security in Saudi Arabia.",
    preferredIndustry: "Controlled Environment Agriculture – Vertical Farming",
    location: "Al-Ahsa or Qassim Region",
    investmentType: "Convertible Debt with Expansion Rights",
    proposal: "Technologies demonstrating 90%+ water efficiency compared to traditional agriculture. Must be adaptable to Saudi climate conditions.",
    roi: "Targeting 21% IRR with Saudi Agricultural Development Fund co-investment potential.",
    links: ["www.desertbloominvest.sa"],
    documents: ["AgriTech_Investment_Criteria.pdf", "Saudi_Food_Security_Strategy.pdf"],
    nextSteps: "Contact us for:\nTechnology adaptation assessment\nPilot farm location selection"
  }
];

// List of sectors for the filter
export const sectors = [
  "All Sectors",
  "Food Processing",
  "Life Sciences & Pharma",
  "Biotechnology",
  "Automotive",
  "Renewables",
  "Machinery & Equipment",
  "Medical Devices & Technology",
  "Minerals & Metals",
  "Chemicals",
  "Building Materials",
  "Aerospace",
  "Maritime",
  "Military",
  "Robotics",
  "Petroleum",
  "Petrochemicals",
  "Mining",
  "Metal Goods",
  "Packaging",
  "Dairy",
  "Dates",
  "Retail & Wholesale",
  "HoReCa",
  "IT, Data & AI",
  "Finance & Banking",
  "Supply Chain & Logistics",
  "Construction & Development",
  "Healthcare Sector",
  "Tourism Sector",
  "Professional Education",
  "Creative Industries",
  "Hospitality Sector",
  "Sport & Lifestyle",
  "Media & Entertainment",
  "R&D & Innovation"
];

// List of countries for the filter
export const countries = [
  "All Countries",
  "Saudi Arabia",
  "United Arab Emirates",
  "Germany",
  "Netherlands",
  "United States",
  "Japan"
];